import React from "react";
import twitterLogo from "./assets/twitter.png";
import "./styles.css";

const TwitterQuote = (props) => {
  const { date, name, username, twitterLink, children } = props;
  return (
    <div className="twitter-quote-container">
      <div className="head">
        <div className="logo">
          <img src={twitterLogo} alt="twitter logo" />
        </div>
        <p>{date}</p>
      </div>
      <div className="body">
        <h3>
          {name}
          <span> ({username})</span>
        </h3>
        <p>{children}</p>
      </div>
      <div className="link">
        <a href={twitterLink} rel="nofollow" target="_blank">
          See {name}'s other tweets
        </a>
      </div>
    </div>
  );
};

export default TwitterQuote;



/** WEBPACK FOOTER **
 ** ./src/views/pages/home/sections/twitterQuotes/components/twitterQuote/index.js
 **/